<template>
    <Modal
        v-if="canRender"
        ref="modalRef"
        v-slot="{ close }"
        :close-button="false"
        :max-width="maxWidth"
        :name="name"
        close-explicitly
        padding-classes="p-0"
        panel-classes="bg-white rounded-[14px] overflow-y-auto"
        @after-leave="$emit('after-leave')"
    >
        <div v-if="title || $slots.title" :class="isMobile ? 'px-4' : 'px-8'" class="border-bottom py-4">
            <div class="flex-column align-items-start">
                <slot name="title">
                    <h3 class="modal-title" v-html="title" />
                </slot>
            </div>
        </div>

        <div :class="isMobile ? 'px-4' : 'px-8'" class="overflow-y-auto py-4" style="flex: 1 1 auto">
            <slot />
        </div>

        <div :class="isMobile ? 'border-top px-4' : 'px-8'" class="py-4">
            <div class="m-0 flex w-100 flex-row items-center justify-center gap-3">
                <slot name="footer">
                    <jet-button :disabled="processing" style="flex: 1" type="button" variant="secondary" @click.stop="cancel">
                        {{ secondaryButtonLabel || trans('general.action.cancel') }}
                    </jet-button>
                    <jet-button
                        v-if="showPrimaryButton"
                        :disabled="processing || primaryButtonDisabled"
                        :is-processing="processing"
                        data-testid="modal-primary-button"
                        style="flex: 1"
                        variant="primary"
                        @click.stop="$emit('submit', $event)"
                    >
                        {{ primaryButtonLabel || trans('general.action.save') }}
                    </jet-button>
                </slot>
            </div>
        </div>
    </Modal>
</template>
<script setup>
import JetButton from '@/Jetstream/Button.vue';
import { Modal } from '@inertiaui/modal-vue';
import { computed, inject, ref } from 'vue';
import { isMobile } from '@/Utils/UseMedia';
import { canRenderModal } from '@/Utils/canRenderModal';

const modalRef = ref(null);

const props = defineProps({
    title: String,
    name: String,
    showPrimaryButton: { type: Boolean, default: true },
    primaryButtonDisabled: { type: Boolean, default: false },
    processing: { type: Boolean, default: false },
    primaryButtonLabel: { type: String },
    secondaryButtonLabel: { type: String },
    maxWidth: { type: String, default: '2xl' },
});

const modalContext = inject('modalContext', null);
const canRender = computed(() => canRenderModal(props.name, modalContext));
const emits = defineEmits(['submit', 'cancel']);

defineExpose({
    reload: (config = {}) => {
        modalRef.value?.reload(config);
    },
    close: () => {
        modalRef.value?.close();
    },
    emit: (event, ...args) => {
        modalRef.value?.emit(event, ...args);
    },
});

function cancel() {
    emits('cancel');
    modalRef.value?.close();
}
</script>

<style>
.im-modal-wrapper.blur-sm {
    display: none;
    filter: none !important;
}
</style>
